/**
 * File formats
 *
 * Please, contribute if you need a missing file format
 */
export var FileFormat;
(function (FileFormat) {
    FileFormat["JPG"] = "jpg";
    FileFormat["JPEG"] = "jpeg";
    FileFormat["PNG"] = "png";
    FileFormat["GIF"] = "gif";
    FileFormat["ICO"] = "ico";
    FileFormat["SVG"] = "svg";
    FileFormat["MP3"] = "mp3";
    FileFormat["MP4"] = "mp4";
    FileFormat["MOV"] = "mov";
    FileFormat["WAV"] = "wav";
    FileFormat["CSV"] = "csv";
    FileFormat["PDF"] = "pdf";
    FileFormat["TXT"] = "txt";
    FileFormat["XML"] = "xml";
    FileFormat["XLS"] = "xls";
    FileFormat["XLSX"] = "xlsx";
    FileFormat["DOC"] = "doc";
    FileFormat["XDOC"] = "xdoc";
})(FileFormat || (FileFormat = {}));
//# sourceMappingURL=FileFormat.js.map